module.exports = __webpack_public_path__ + "img/mortgagePromo.94d122e7.jpg";